import { memo, useCallback } from "react"
import { useLocalization } from "@tm/localization"
import { Box, Collapse, LinearProgress, Stack } from "@mui/material"
import { Icon } from "../../../muiStyled/DataDisplay/Icons"
import { Typography } from "../../../muiStyled/DataDisplay/typographie"
import { IconButton } from "../../../muiStyled/Inputs/button"
import { Tooltip } from "../../../muiStyled/DataDisplay/tooltip"
import { ListNoteItem } from "./ListNoteItem"
import { SubArticleContainer } from "../SubArticleContainer"
import { useNotes } from "./useNotes"
import { useDefaultArticleItemState } from "../ContextProviderStates/DefaultArticleItemState"
import { Dialog } from "../../dialog"
import { TileNoteItem } from "./TileNoteItem"

export const Notes = memo(() => {
    const { translateText } = useLocalization()
    const { handleDelete, handleSave, isLoading, visible, hide, displayNotes } = useNotes()
    const tileView = useDefaultArticleItemState((x) => x.options.tileView)

    const renderListNotes = useCallback(() => {
        return (
            <Stack rowGap={1} columnGap={2} display="grid" gridTemplateColumns="auto 1fr auto">
                {displayNotes.map((note) => (
                    <ListNoteItem key={note.noteId} note={note} onSave={handleSave} onDelete={handleDelete} isLoading={isLoading} />
                ))}
            </Stack>
        )
    }, [displayNotes, handleDelete, handleSave, isLoading])

    const renderTileNotes = useCallback(() => {
        return (
            <Stack rowGap={1} columnGap={0.5} display="grid" gridTemplateColumns="auto 1fr auto" alignItems="center">
                {displayNotes.map((note) => (
                    <TileNoteItem key={note.noteId} note={note} onSave={handleSave} onDelete={handleDelete} isLoading={isLoading} />
                ))}
            </Stack>
        )
    }, [displayNotes, handleDelete, handleSave, isLoading])

    return tileView ? (
        <Dialog open={visible} onOutsideClick={hide} maxWidth="lg">
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                <Typography variant="h1">{translateText(14)}</Typography>
                <Tooltip title={translateText(70)}>
                    <IconButton variant="contained" size="extralarge" onClick={hide} disabled={isLoading}>
                        <Icon name="close" />
                    </IconButton>
                </Tooltip>
            </Stack>
            <Box minHeight={3}>{isLoading && <LinearProgress sx={{ height: 3 }} />}</Box>
            {renderTileNotes()}
        </Dialog>
    ) : (
        <Collapse in={visible}>
            {visible && (
                <SubArticleContainer title={translateText(14)} onClose={hide} isLoading={isLoading}>
                    {renderListNotes()}
                </SubArticleContainer>
            )}
        </Collapse>
    )
})
